import { render } from "./Attendtotal.vue?vue&type=template&id=4652d9e8&scoped=true"
import script from "./Attendtotal.vue?vue&type=script&lang=js"
export * from "./Attendtotal.vue?vue&type=script&lang=js"

import "./Attendtotal.vue?vue&type=style&index=0&id=4652d9e8&scoped=true&lang=css"

import exportComponent from "/var/www/html/dongan_teens2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4652d9e8"]])

export default __exports__